import React from "react";
import Project from "./Project";
import PROJECTS from "../data/data.json";
import { useNavigate } from "react-router-dom";
import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";

function Projects() {
  const navigate = useNavigate();
  const [subtitle, subtitleInView] = useInView({
    triggerOnce: true, // Animation triggered only once
    threshold: 0.5, // Adjust the threshold as needed
  });
  const [title, titleInView] = useInView({
    triggerOnce: true, // Animation triggered only once
    threshold: 0.5, // Adjust the threshold as needed
  });
  const animationVariants = {
    hidden: {
      opacity: 0,
      y: 50,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 1,
        ease: "easeInOut",
      },
    },
  };
  return (
    <div className="projects-section">
      <motion.div
        className="sub-title"
        ref={subtitle}
        initial="hidden"
        animate={subtitleInView ? "visible" : "hidden"}
        variants={animationVariants}
      >
        Projects
      </motion.div>
      <motion.div
        className="title more-row"
        ref={title}
        initial="hidden"
        animate={titleInView ? "visible" : "hidden"}
        variants={animationVariants}
      >
        Latest projects{" "}
        <span
          className="more"
          onClick={() => {
            navigate(`/projects`);
          }}
        >
          more
        </span>
      </motion.div>
      <div className="projects">
        {PROJECTS.map(
          (item, index) => index < 3 && <Project key={index} item={item} />
        )}
      </div>
    </div>
  );
}

export default Projects;
